import React from 'react';
import {
  MDBCol,
  MDBRow,
  MDBInput,
  MDBModal,
  MDBNavLink,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBDataTable,
  MDBListGroup, MDBListGroupItem,
  MDBContainer, MDBInputGroup,
  MDBBtn
} from 'mdbreact';
import './invoiceTemplates-view.css';
import '../../styles/page-common.css';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import Breadcrumb from '../../components/breadcrumb';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';

class HomeView extends React.Component {

  state = {
    modal: false,
    pdfModal: false,
    newInvoice: {},
    newLineItem: {},
    rankType: 'all'
  }

  handleChange = (value, prop) => {
    var t = this.state.newInvoice;
    t[prop] = value;
    this.setState({
      newInvoice: t
    });
  }

  handleLineChange = (value, prop) => {
    var t = this.state.newLineItem;
    t[prop] = value;
    this.setState({
      newLineItem: t
    });
  }

  togglePDF = () => {
    this.setState({
      pdfModal: !this.state.pdfModal,
    });
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      newInvoice: {},
    });
  }

  addLineItem = () => {
    this.setState({
      newInvoice: {
        ...this.state.newInvoice,
        descriptions: this.state.newInvoice.descriptions ? [...this.state.newInvoice.descriptions, { ...this.state.newLineItem }] : [{ ...this.state.newLineItem }]
      }
    });
  }

  deleteLineItem = (desc) => {
    this.setState({
      newInvoice: {
        ...this.state.newInvoice,
        descriptions: this.state.newInvoice.descriptions.filter(item => item.description != desc)
      }
    });
  }

  edit = (invoice) => {
    this.setState({
      modal: !this.state.modal,
      newInvoice: invoice
    });
  }

  componentDidMount() {
    this.props.getInvoiceTemplates();
  }

  createInvoice = () => {
    this.props.createInvoice(this.state.newInvoice);
    this.setState({
      modal: !this.state.modal,
      newInvoice: ''
    });
  }

  scrollToTop = () => window.scrollTo(0, 0);

  getDataFromURL = (url) => new Promise((resolve, reject) => {
    setTimeout(() => {
      fetch(url)
        .then(response => response.blob())
        .then(data => {
          resolve(data)
        });
    });
  }, 2000);

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    var Invoices = [];
    console.log(this.props);

    if (this.props.invoiceTemplates && this.props.invoiceTemplates.length > 0) {
      Invoices = this.props.invoiceTemplates.map(p => {
        return {
          name: p.invoiceTemplateName,
          view: <Link to={"/invoiceTemplate/" + p._id}><MDBBtn color="yellow accent-4" rounded outline size="sm">view</MDBBtn></Link>,
        }
      });
    }

    const data = {
      columns: [
        {
          label: 'Name',
          field: 'name',
          sort: 'asc'
        },
        {
          label: '',
          field: 'view',
          sort: 'asc'
        }
      ],
      rows: Invoices
    };

    return (
      <div className="content-wrapper">
        <SpinnerView showSpinner={this.props.loading} />

        {/* Page Header */}
        <div className="page-header">
          <h1 className="page-title">
            <i className="fas fa-file-contract"></i>
            Invoice Templates
          </h1>
        </div>

        <div style={{ padding: '0 20px 20px 20px' }}>
        <MDBDataTable
          disableRetreatAfterSorting={true}
          striped
          bordered
          small
          data={data}
        />

        <Fab onClick={this.toggle} className="fab primary-color" aria-label="add" style={{
          position: 'fixed'
        }}>
          <AddIcon />
        </Fab>
        </div>
      </div>
    );
  }
}
/*
    descriptions:[{
        name:"name",
        "price":100
    }],
    */
export default HomeView;
